/**
 * This file is meant to be reference in the solution to assist with testing.
 * Avoid importing non-production modules.
 */
import env from 'config/environment';

const isProduction = env.IsProduction();
const testPrefix = '__test__';

export const addTestClassName = (className: string) => (isProduction === true ? '' : `${testPrefix}${className}`);

export const getTestClassName = (className: string) => `.${testPrefix}${className}`;
